import { styled } from '@mui/material';
import Box from '@mui/material/Box';

export const StyledRmsBox = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
`;
